import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, X, Calendar, Users, Camera, Play, Pause } from 'lucide-react';
import img1 from '../Assests/2024/1.webp';
import img2 from '../Assests/2024/2.webp';
import img3 from '../Assests/2024/3.webp';
import img4 from '../Assests/2024/4.webp';
import img5 from '../Assests/2024/5.webp';
import img6 from '../Assests/2024/6.webp';
import img7 from '../Assests/2024/7.webp';
import img8 from '../Assests/2024/8.webp';
import img9 from '../Assests/2024/9.webp';
import img10 from '../Assests/2024/10.webp';
import img11 from '../Assests/2024/11.webp';
import img12 from '../Assests/2024/12.webp';
import img13 from '../Assests/2024/13.webp';
import img14 from '../Assests/2024/14.webp';
import img15 from '../Assests/2024/15.webp';
import img16 from '../Assests/2024/16.webp';
import img17 from '../Assests/2024/17.webp';
import img18 from '../Assests/2024/18.webp';
import img19 from '../Assests/2024/19.webp';
import img20 from '../Assests/2024/20.webp';
import img21 from '../Assests/2024/21.webp';
import img22 from '../Assests/2024/22.webp';
import img23 from '../Assests/2024/23.webp';
import img24 from '../Assests/2024/24.webp';
import img231 from '../Assests/2023/1.webp';
import img232 from '../Assests/2023/2.webp';
import img233 from '../Assests/2023/3.webp';
import img234 from '../Assests/2023/4.webp';
import img235 from '../Assests/2023/5.webp';
import img236 from '../Assests/2023/6.webp';
import img237 from '../Assests/2023/7.webp';
import img238 from '../Assests/2023/8.webp';
import img239 from '../Assests/2023/9.webp';
import img2310 from '../Assests/2023/10.webp';
import img2311 from '../Assests/2023/11.webp';
import img2312 from '../Assests/2023/12.webp';
import img2313 from '../Assests/2023/13.webp';
import img2314 from '../Assests/2023/14.webp';
import img2315 from '../Assests/2023/15.webp';
import img2316 from '../Assests/2023/16.webp';
import img2317 from '../Assests/2023/17.webp';
import img2318 from '../Assests/2023/18.webp';
import img2319 from '../Assests/2023/19.webp';
import img2320 from '../Assests/2023/20.webp';
import img2321 from '../Assests/2023/21.webp';
import img2322 from '../Assests/2023/22.webp';
import img2323 from '../Assests/2023/23.webp';
import img2324 from '../Assests/2023/24.webp';
import img2325 from '../Assests/2023/25.webp';
import img2326 from '../Assests/2023/26.webp';
import img2327 from '../Assests/2023/27.webp';
import img2328 from '../Assests/2023/28.webp';

// 2019 Images (using the min versions)
import img191 from '../Assests/2019/1-min.webp';
import img192 from '../Assests/2019/2-min.webp';
import img193 from '../Assests/2019/3-min.webp';
import img194 from '../Assests/2019/4-min.webp';
import img195 from '../Assests/2019/5-min.webp';
import img196 from '../Assests/2019/6-min.webp';
import img197 from '../Assests/2019/7-min.webp';
import img198 from '../Assests/2019/8-min.webp';
import img199 from '../Assests/2019/9-min.webp';
import img1910 from '../Assests/2019/10-min.webp';

const galleryImageContext = require.context('../Assests/2025/optimized', false, /\.JPG$/);
const galleryImages = galleryImageContext.keys()
  .sort()
  .map((imagePath) => galleryImageContext(imagePath));

const Gallery = () => {
  const [selectedYear, setSelectedYear] = useState('2025');
  const [selectedImage, setSelectedImage] = useState(null);
  const [currentSlideIndex, setCurrentSlideIndex] = useState(0);
  const [isAutoPlaying, setIsAutoPlaying] = useState(true);
  const [slidesToShow, setSlidesToShow] = useState(3);

  const galleryData = {
    '2025': {
      year: '2025',
      title: 'Open House 2025',
      description: '',
      photos: [
        ...galleryImages
      ].map((url, index) => ({ id: index + 1, url, category: '' }))
    },
    '2024': {
      year: '2024',
      title: 'Open House 2024',
      description: 'Latest innovations and research showcases',
      photos: [
        { id: 1, url: img1, category: 'exhibition' },
        { id: 2, url: img2, category: 'ceremony' },
        { id: 3, url: img3, category: 'demo' },
        { id: 4, url: img4, category: 'tour' },
        { id: 5, url: img5, category: 'interaction' },
        { id: 6, url: img6, category: 'awards' },
        { id: 7, url: img7, category: 'exhibition' },
        { id: 8, url: img8, category: 'ceremony' },
        { id: 9, url: img9, category: 'demo' },
        { id: 10, url: img10, category: 'tour' },
        { id: 11, url: img11, category: 'interaction' },
        { id: 12, url: img12, category: 'awards' },
        { id: 13, url: img13, category: 'exhibition' },
        { id: 14, url: img14, category: 'ceremony' },
        { id: 15, url: img15, category: 'demo' },
        { id: 16, url: img16, category: 'tour' },
        { id: 17, url: img17, category: 'interaction' },
        { id: 18, url: img18, category: 'awards' },
        { id: 19, url: img19, category: 'exhibition' },
        { id: 20, url: img20, category: 'ceremony' },
        { id: 21, url: img21, category: 'demo' },
        { id: 22, url: img22, category: 'tour' },
        { id: 23, url: img23, category: 'interaction' },
        { id: 24, url: img24, category: 'awards' }
      ]
    },
    '2023': {
      year: '2023',
      title: 'Open House 2023',
      description: 'Celebrating excellence in engineering and technology',
      photos: [
        { id: 1, url: img231, category: 'ceremony' },
        { id: 2, url: img232, category: 'exhibition' },
        { id: 3, url: img233, category: 'demo' },
        { id: 4, url: img234, category: 'tour' },
        { id: 5, url: img235, category: 'interaction' },
        { id: 6, url: img236, category: 'awards' },
        { id: 7, url: img237, category: 'exhibition' },
        { id: 8, url: img238, category: 'ceremony' },
        { id: 9, url: img239, category: 'demo' },
        { id: 10, url: img2310, category: 'tour' },
        { id: 11, url: img2311, category: 'interaction' },
        { id: 12, url: img2312, category: 'awards' },
        { id: 13, url: img2313, category: 'exhibition' },
        { id: 14, url: img2314, category: 'ceremony' },
        { id: 15, url: img2315, category: 'demo' },
        { id: 16, url: img2316, category: 'tour' },
        { id: 17, url: img2317, category: 'interaction' },
        { id: 18, url: img2318, category: 'awards' },
        { id: 19, url: img2319, category: 'exhibition' },
        { id: 20, url: img2320, category: 'ceremony' },
        { id: 21, url: img2321, category: 'demo' },
        { id: 22, url: img2322, category: 'tour' },
        { id: 23, url: img2323, category: 'interaction' },
        { id: 24, url: img2324, category: 'awards' },
        { id: 25, url: img2325, category: 'exhibition' },
        { id: 26, url: img2326, category: 'ceremony' },
        { id: 27, url: img2327, category: 'demo' },
        { id: 28, url: img2328, category: 'tour' }
      ]
    },
    '2019': {
      year: '2019',
      title: 'Open House 2019',
      description: 'Pioneering research and academic excellence',
      photos: [
        { id: 1, url: img191, category: 'ceremony' },
        { id: 2, url: img192, category: 'exhibition' },
        { id: 3, url: img193, category: 'demo' },
        { id: 4, url: img194, category: 'tour' },
        { id: 5, url: img195, category: 'interaction' },
        { id: 6, url: img196, category: 'awards' },
        { id: 7, url: img197, category: 'exhibition' },
        { id: 8, url: img198, category: 'ceremony' },
        { id: 9, url: img199, category: 'demo' },
        { id: 10, url: img1910, category: 'tour' }
      ]
    }
  };

  const currentGallery = galleryData[selectedYear];

  // Update slides to show based on screen size
  useEffect(() => {
    const updateSlidesToShow = () => {
      if (window.innerWidth < 640) {
        setSlidesToShow(1);
      } else if (window.innerWidth < 1024) {
        setSlidesToShow(2);
      } else {
        setSlidesToShow(3);
      }
    };

    updateSlidesToShow();
    window.addEventListener('resize', updateSlidesToShow);
    return () => window.removeEventListener('resize', updateSlidesToShow);
  }, []);

  // Auto-play functionality
  useEffect(() => {
    if (isAutoPlaying) {
      const interval = setInterval(() => {
        setCurrentSlideIndex((prev) => {
          const nextIndex = prev + 1;
          return nextIndex >= currentGallery.photos.length ? 0 : nextIndex;
        });
      }, 3000);

      return () => clearInterval(interval);
    }
  }, [isAutoPlaying, currentGallery.photos.length]);

  // Reset slide index when changing years
  useEffect(() => {
    setCurrentSlideIndex(0);
  }, [selectedYear]);

  const openLightbox = (photo, index) => {
    setSelectedImage(photo);
    setIsAutoPlaying(false);
  };

  const closeLightbox = () => {
    setSelectedImage(null);
    setIsAutoPlaying(true);
  };

  const navigateSlide = (direction) => {
    if (direction === 'next') {
      setCurrentSlideIndex(prev => {
        const nextIndex = prev + 1;
        return nextIndex >= currentGallery.photos.length ? 0 : nextIndex;
      });
    } else {
      setCurrentSlideIndex(prev => {
        const prevIndex = prev - 1;
        return prevIndex < 0 ? currentGallery.photos.length - slidesToShow : prevIndex;
      });
    }
  };

  const goToSlide = (index) => {
    setCurrentSlideIndex(index);
  };

  const toggleAutoPlay = () => {
    setIsAutoPlaying(!isAutoPlaying);
  };

  const isPhotoInBuffer = (photoIndex) => {
    const photoCount = currentGallery.photos.length;
    const distance = Math.abs(photoIndex - currentSlideIndex);
    return Math.min(distance, photoCount - distance) <= slidesToShow + 1;
  };

  return (
    <section id="gallery" className="py-20 bg-gradient-to-br from-gray-50 to-gray-100">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-16">
          <h2 className="text-5xl font-bold text-gray-800 mb-6 flex items-center justify-center gap-4">
            <Camera className="w-12 h-12 text-blue-600" />
            Open House Gallery
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Relive the moments from our previous Open House events and get excited for what's coming next
          </p>
        </div>

        {/* Year Selector - Horizontal */}
        <div className="flex justify-center mb-12">
          <div className="bg-white rounded-2xl p-2 shadow-lg flex">
            <button
              onClick={() => setSelectedYear('2025')}
              className={`px-6 py-3 mx-1 rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 ${
                selectedYear === '2025'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Calendar className="w-4 h-4" />
              2025
            </button>
            <button
              onClick={() => setSelectedYear('2024')}
              className={`px-6 py-3 mx-1 rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 ${
                selectedYear === '2024'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Calendar className="w-4 h-4" />
              2024
            </button>
            <button
              onClick={() => setSelectedYear('2023')}
              className={`px-6 py-3 mx-1 rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 ${
                selectedYear === '2023'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Calendar className="w-4 h-4" />
              2023
            </button>
            <button
              onClick={() => setSelectedYear('2019')}
              className={`px-6 py-3 mx-1 rounded-xl font-semibold transition-all duration-300 flex items-center gap-2 ${
                selectedYear === '2019'
                  ? 'bg-gradient-to-r from-blue-600 to-purple-600 text-white shadow-lg'
                  : 'text-gray-600 hover:bg-gray-100'
              }`}
            >
              <Calendar className="w-4 h-4" />
              2019
            </button>
          </div>
        </div>

        {/* Gallery Info */}
        <div className="text-center mb-12">
          <h3 className="text-3xl font-bold text-gray-800 mb-2">{currentGallery.title}</h3>
          {currentGallery.description && (
            <p className="text-lg text-gray-600">{currentGallery.description}</p>
          )}
          <div className="flex justify-center items-center gap-4 mt-4">
            <div className="flex items-center gap-2 bg-white rounded-full px-4 py-2 shadow-md">
              <Users className="w-4 h-4 text-blue-600" />
              <span className="text-sm font-medium">{currentGallery.photos.length} Photos</span>
            </div>
          </div>
        </div>

        {/* Slideshow Container */}
        <div className="relative bg-white rounded-3xl shadow-2xl p-8 mx-auto max-w-7xl">
          {/* Slideshow Controls */}
          <div className="flex justify-between items-center mb-6">
            <h4 className="text-2xl font-bold text-gray-800">Photo Slideshow</h4>
            <button
              onClick={toggleAutoPlay}
              className="flex items-center gap-2 bg-gradient-to-r from-blue-600 to-purple-600 text-white px-4 py-2 rounded-full hover:shadow-lg transition-all duration-300"
            >
              {isAutoPlaying ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
              {isAutoPlaying ? 'Pause' : 'Play'}
            </button>
          </div>

          {/* Main Slider */}
          <div className="relative overflow-hidden rounded-2xl">
            <div 
              className="flex transition-transform duration-500 ease-out"
              style={{ 
                transform: `translateX(-${(currentSlideIndex * 100) / slidesToShow}%)`,
              }}
            >
              {/* Create extended array for infinite scrolling */}
              {[...currentGallery.photos, ...currentGallery.photos.slice(0, slidesToShow)].map((photo, index) => {
                const photoIndex = index % currentGallery.photos.length;
                const shouldLoadPhoto = isPhotoInBuffer(photoIndex);

                return (
                  <div
                    key={`${photo.id}-${Math.floor(index / currentGallery.photos.length)}`}
                    className="flex-shrink-0 px-2"
                    style={{ width: `${100 / slidesToShow}%` }}
                  >
                    <div
                      className="group relative bg-white rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 cursor-pointer transform hover:-translate-y-2"
                      onClick={() => openLightbox(photo, photoIndex)}
                    >
                      <div className="aspect-w-16 aspect-h-12 bg-gray-200">
                        {shouldLoadPhoto ? (
                          <img
                            src={photo.url}
                            alt={`Open House ${currentGallery.year} ${photo.id}`}
                            className="w-full h-80 object-cover group-hover:scale-105 transition-transform duration-300"
                            loading="lazy"
                            decoding="async"
                            onError={(e) => {
                              e.target.style.display = 'none';
                              e.target.nextSibling.style.display = 'flex';
                            }}
                          />
                        ) : null}
                        <div className={`w-full h-80 bg-gradient-to-br from-gray-300 to-gray-400 flex items-center justify-center text-gray-600 ${shouldLoadPhoto ? 'hidden' : ''}`}>
                          <div className="text-center">
                            <Camera className="w-8 h-8 mx-auto mb-2" />
                            <span className="text-sm">Image Loading...</span>
                          </div>
                        </div>
                      </div>
{/* 
                      {photo.category && <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="absolute bottom-4 left-4 right-4">
                          <span className="inline-block px-3 py-1 bg-white/20 backdrop-blur-sm rounded-full text-white text-sm font-medium">
                            {photo.category}
                          </span>
                        </div>
                      </div>} */}

                      <div className="absolute top-4 right-4 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                        <div className="bg-white/20 backdrop-blur-sm rounded-full p-2">
                          <Camera className="w-5 h-5 text-white" />
                        </div>
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Navigation Arrows */}
            <button
              onClick={() => navigateSlide('prev')}
              className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 z-10"
            >
              <ChevronLeft className="w-6 h-6 text-gray-800" />
            </button>

            <button
              onClick={() => navigateSlide('next')}
              className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 backdrop-blur-sm rounded-full p-3 shadow-lg hover:bg-white hover:shadow-xl transition-all duration-300 z-10"
            >
              <ChevronRight className="w-6 h-6 text-gray-800" />
            </button>
          </div>

          {/* Slide Indicators */}
          <div className="flex justify-center mt-8 gap-2">
            {currentGallery.photos.map((_, index) => (
              <button
                key={index}
                onClick={() => goToSlide(index)}
                className={`w-3 h-3 rounded-full transition-all duration-300 ${
                  currentSlideIndex % currentGallery.photos.length === index 
                    ? 'bg-gradient-to-r from-blue-600 to-purple-600 scale-125' 
                    : 'bg-gray-300 hover:bg-gray-400'
                }`}
              />
            ))}
          </div>

          {/* Progress Bar */}
          <div className="mt-6 bg-gray-200 rounded-full h-1 overflow-hidden">
            <div 
              className="h-full bg-gradient-to-r from-blue-600 to-purple-600 transition-all duration-300"
              style={{ 
                width: `${((currentSlideIndex % currentGallery.photos.length + 1) / currentGallery.photos.length) * 100}%` 
              }}
            />
          </div>
        </div>

        {/* Thumbnail Strip */}
        <div className="mt-8 overflow-hidden">
          <div className="flex gap-4 justify-center flex-wrap">
            {currentGallery.photos.slice(currentSlideIndex, currentSlideIndex + 6).map((photo, index) => (
              <div
                key={`thumb-${photo.id}`}
                className="w-20 h-20 rounded-lg overflow-hidden cursor-pointer hover:ring-4 hover:ring-blue-300 transition-all duration-300 bg-gray-200"
                onClick={() => openLightbox(photo, currentSlideIndex + index)}
              >
                <img
                  src={photo.url}
                  alt={`Thumbnail ${index + 1}`}
                  className="w-full h-full object-cover"
                  loading="lazy"
                  onError={(e) => {
                    e.target.style.display = 'none';
                    e.target.parentElement.classList.add('flex', 'items-center', 'justify-center');
                    e.target.parentElement.innerHTML = '<div class="text-gray-500 text-xs">No Image</div>';
                  }}
                />
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Enhanced Lightbox with Navigation */}
      {selectedImage && (
        <div className="fixed inset-0 bg-black/95 z-50 flex items-center justify-center p-4" onClick={closeLightbox}>
          <div className="relative max-w-6xl max-h-full" onClick={(e) => e.stopPropagation()}>
            {/* Close Button */}
            <button
              onClick={closeLightbox}
              className="absolute top-4 right-4 z-10 bg-white/20 backdrop-blur-sm rounded-full p-3 text-white hover:bg-white/30 transition-all duration-200 hover:scale-110"
            >
              <X className="w-6 h-6" />
            </button>

            {/* Main Image */}
            <div className="relative bg-gray-200 rounded-lg overflow-hidden">
              <img
                src={selectedImage.url}
                alt={`Open House ${currentGallery.year} ${selectedImage.id}`}
                className="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl mx-auto block"
                onError={(e) => {
                  e.target.style.display = 'none';
                  e.target.nextSibling.style.display = 'flex';
                }}
              />
              <div className="w-full h-96 bg-gradient-to-br from-gray-300 to-gray-400 flex items-center justify-center text-gray-600 hidden">
                <div className="text-center">
                  <Camera className="w-12 h-12 mx-auto mb-4" />
                  <span className="text-lg">Image not available</span>
                </div>
              </div>
            </div>

            {/* Image Info */}
            {selectedImage.category && <div className="absolute bottom-4 left-4 right-4 bg-black/50 backdrop-blur-sm rounded-lg p-4">
              <h4 className="text-white font-semibold text-xl mb-2">Open House {currentGallery.year}</h4>
              <div className="flex items-center justify-between">
                <span className="text-white/90 text-sm bg-white/20 px-3 py-1 rounded-full">
                  {selectedImage.category}
                </span>
                <span className="text-white/80 text-sm">
                  Click outside to close
                </span>
              </div>
            </div>}
          </div>
        </div>
      )}
    </section>
  );
};

export default Gallery;